import type {
  DeletePromptMutation,
  DeletePromptMutationVariables,
} from '#src/graphql/generated';
import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

export const DELETE_PROMPT: TypedDocumentNode<
  DeletePromptMutation,
  DeletePromptMutationVariables
> = gql`
  mutation DeletePrompt($input: DeletePromptInput!) {
    deletePrompt(input: $input) {
      message
      success
    }
  }
`;
